export default __webpack_public_path__ + "static/media/O_halliroom.459563a8.mp4";